import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpEventType } from "@angular/common/http";
import { Router, NavigationExtras, NavigationEnd } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { retry, catchError , map} from "rxjs/operators";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";
// import * as moment from "moment";
import moment from 'moment-timezone';
import { environment } from "../../environments/environment";
import { getLocalJSON } from '../_helpers/storage.util';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public currency:any='$';
  public playerBase:any='https://cdn.jwplayer.com/players/';
  
  baseUrl =  `${environment.apiEndPoint}`;

  public giverSelectedUser = new Subject<any>();
  private currentUser: any = {};
  private subject = new Subject<any>();
  public currYear = new Date().getFullYear();
  public Language: any;
  public versions:any=localStorage.getItem('grw_version');
  public monthArray: any = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  public dayArray :any=['Sun','Mon','Tue','wed','Thu','Fri','Sat'];
  // public Harray:any=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];
  // public Marray:any=[];
  // public Sarray:any=[];

  
  constructor(
    public http: HttpClient,
    private router: Router,
    private location: Location,
    public toastr: ToastrService,
  ) {}

  // Http Options
  getHeaderLogin(type = 2) {
    var data:any = "";
    if (localStorage.getItem('grw_token')) {
      data ='Bearer '+  localStorage.getItem('grw_token');
    }
    if (type == 1) {
      return {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    } else {
      return {
        headers: new HttpHeaders({
          "X-Authorization": data,
          "device-type": "Browser",
          "device-token": "8749",
          "Version": "1.0.0",
          "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        }),
      };
    }
  }
  // Http Options
  getHeadersLogin() {
    var data :any= "";
    if (localStorage.getItem('grw_token')) {
      data = 'Bearer '+ localStorage.getItem('grw_token');
    }
    return {
      headers: new HttpHeaders({
        //'Content-Type' : 'application/json, text/plain, */*',
        "X-Authorization":  data,
        "device-type": "Browser",
        "device-token": "8745",
        "Version": "1.0.0",
        "time-zone":moment.tz.guess(),
          "Accept-Language":'en',
        // 'lat':lat,
        // 'long':lang,
        // 'userid':currentUserId,
        // 'parentId':parentid,
        // 'timeZone':moment.tz.guess(),
        // 'timeZoneOffset':'',
        // 'role':role_id,
      }),
    };
  }

  setSubject(obj: any) {
    this.subject.next({ loginData: obj });
  }

  back() {
    this.location.back();
  }

  forword() {
    this.location.forward();
  }

  logOut() {
    var arr: any = [];
    const value: any = localStorage;    
    for (var i = 0; i < value.length; i++) {
      if (value.key(i).substring(0, 4) == 'grw_') {
        if (value.key(i) != 'grw_Remember') {
          arr.push(value.key(i));
        }
      }
    }
    for (var i = 0; i < arr.length; i++) {
      value.removeItem(arr[i]);
    }
  }

  /*
   * return data array
   */
  getSubject(): Observable<any> {
    return this.subject
      .asObservable()
      .pipe(retry(0), catchError(this.handleError))
  }

  // Common post api
  PostApis(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }



  // Common get api
  GetApi(url: any) {
    return this.http
      .get<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  // Common get api
  DeleteApi(url: any) {
    return this.http
      .delete<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      if(response.version.master_version > this.versions){
        this.getAllMasterData();
      }
      return data;
    }))
  }

  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // successAlert for fire toast/...
  successAlert(msg: any) {
    this.toastr.success(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000,
    });
  }

  warningAlert(msg: any) {
    this.toastr.warning(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000,
    });
  }

  // successAlert for fire toast/...
  dangerAlert(msg: any) {
    this.toastr.error(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000,
    });
  }

  // convert date in (yyyy-mm-dd)
  ToDate(date: any) {
    var day = date.toString().slice(4, 15);
    var day1 = day.split(" ");
    var newmonth =
      this.monthArray.findIndex((rank: any) => rank === day1[0]) + 1;
    if (newmonth < 10) {
      newmonth = "0" + newmonth;
    }
    var dob = day1[2] + "-" + newmonth + "-" + day1[1];
    // var dob = day1[1] + "-" + newmonth + "-" + day1[2];

    return dob;
  }

    ToDate1(date: any) {
    var day =date.split('T'); 
    var day1 = day[0].split("-");
    // var newmonth =
    //   this.monthArray.findIndex((rank: any) => rank === day1[0]) + 1;
    // if (newmonth < 10) {
    //   newmonth = "0" + newmonth;
    // }
    var dob = day1[2] + "/" + day1[1] + "/" + day1[0];
    // var dob = day1[1] + "-" + newmonth + "-" + day1[2];

    return dob;
  }
  convertDate(date: any) {
    return moment(date).format("HH:mm DD MMMM YYYY");
  }

  checkStringLength(content: string) {
    return content == undefined ? false : true;
  }

  toTimestamp(strDate:any){
    var date = new Date(strDate);
    return date
  }

  ExpiryCheck(month:any,year:any){
    var today = new Date();
      var currYear = today.getFullYear();
      var months =  today.getMonth() + 1;
      // var newmonth:any;
      // if(months < 10){
      //   newmonth = '0'+ months;
      // }
      if((month < months && year <=  currYear )||  year <  currYear) {
        // this.dangerAlert('Expiry Month & Year is not valid')
        return false;
      } else{
        return 1;
      }
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  TextOnly(event:any,type:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if(type==1){
      if (charCode == 64 ) {
        return false;
      }
    }else {
      
    }
    
    return true;
  }

   dateConvert(Dates:any,type:any){
    var event_date_start_utc1;
    event_date_start_utc1 = new Date(Dates*1000);
    var hours:any = event_date_start_utc1.getHours();
    var minutes:any = event_date_start_utc1.getMinutes();
    var newformat = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var date :any = event_date_start_utc1.getDate();
    if(date < 10){
      date = '0'+ date;
    }
    var month = event_date_start_utc1.getMonth();
    var months = month +1;
    var year = event_date_start_utc1.getFullYear();
    var day = event_date_start_utc1.getDay();
    if(type == 1){
      var newdate = date+'/'+months +'/'+ year;
      return  newdate;
    } else if(type == 2){
      var newdate = this.dayArray[day]+' '+this.monthArray[month] +' '+   date +' '+ year;
      return  newdate;
    } else  if(type == 3){
      var newdate = date+' '+this.monthArray[month] +' '+ year;
      return  newdate;
    } else if(type == 4){
      var jj = Dates.split('-');
      var kk = parseInt(jj[1])-1;
      var newdate = jj[0]+' '+this.monthArray[kk] +', '+ jj[2];
      return  newdate;
    } else {
      var newdate = date+'/'+months +'/'+ year +' ' + hours + ':' + minutes + ' ' + newformat;
      return  newdate;
    }
  }

  getAllMasterData(){
    const url = "/common-contents"; 
    this.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self=this,ss:any=[],dd:any=[];      
        response.data.suitability.filter((el:any)=>{
          el.check = false;
        })
        response.data.race.filter((el:any)=>{
          if(el.name!='Other' && el.name!='other'){
            ss.push(el);
          } else {
            dd=el;
          }
          el.chcecked = false;
        })
        ss.push(dd);
        response.data.race =ss;
        ss=[],dd=[];
        response.data.expertise.filter((el:any)=>{
          if(el.childContent==false){
            ss.push(el);
          } else {
            dd=el;
          }
          el.chcecked = false;
        })
        ss.push(dd);
        response.data.expertise =ss;
        ss=[],dd=[];
        localStorage.setItem('grw_materData',JSON.stringify(response.data));
      }
      localStorage.setItem('grw_version',response.version.master_version);
    }), (error) => { });
  }

  dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  get_parts_count(file: any) {
    let minimum_part_size;
    minimum_part_size = 6 * 1024 * 1024;
    let size = file.size;
    return Math.floor(size / minimum_part_size) + 1;
  }

  dateCon(date:any){
    var mm =date.split('T');
    return mm[0];
  }
  
  dateTImeCon(date:any){
    var mm =date.split('T');
    var jj= mm[1].split(':')
    var hoursEnd = jj[0] < 10 ? "0" + jj[0] : jj[0];
    var minutes = jj[1] < 10 ? "0" + jj[1] : jj[1];
    var am_pm = jj[0] >= 12 ? "PM" : "AM";
    var time = jj[0] + ":" + jj[1] + ":00 " 
    // + am_pm;
    return time;
  }

  timeago(date:any){
    var s:any=new Date();
    const seconds = Math.floor((s - date) / 1000);
    let interval = Math.floor(seconds / 31536000);
    if (interval > 1) {
      return interval + ' years ago';
    }  
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + ' months ago';
    }  
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + ' days ago';
    }  
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + ' hours ago';
    }  
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + ' minutes ago';
    }  
    if(seconds < 10) return 'just now';  
    return Math.floor(seconds) + ' seconds ago';
  }

  
  async getConversionRate11(type:any){ 
    var url = 'https://api.exchangerate-api.com/v4/latest/' + type;
    await this.http.get(url).pipe(retry(0), catchError(this.handleError)).toPromise().then(((response:any)=>{
      if(response.rates){
          if( type == localStorage.getItem('grw_logincurrency')){
            localStorage.setItem('grw_excahngevalue',<any> JSON.stringify(response.rates));
          } else {
            localStorage.setItem('grw_new_excahngevalue',<any> JSON.stringify(response.rates));
          }
      }
    }));
   }

  async getConversionRate(type:any,ss:any){ 
    var url = 'https://api.exchangerate-api.com/v4/latest/' + type;
    await this.http.get(url).pipe(retry(0), catchError(this.handleError)).toPromise().then(((response:any)=>{
      if(response.rates){
        if(ss == 1 ){
          localStorage.setItem('grw_gift_excahngevalue',<any> JSON.stringify(response.rates));
        } else { 
          if( type == localStorage.getItem('grw_logincurrency')){
            localStorage.setItem('grw_excahngevalue',<any> JSON.stringify(response.rates));
          } else {
            localStorage.setItem('grw_new_excahngevalue',<any> JSON.stringify(response.rates));
          }
        }
      }
    }));
   }

   exchangeCurrency(type:any,cc:any,amount:any){
    if(parseFloat(amount) == 0 ) { 
    return parseFloat(amount).toFixed(2); 
  } else {
    var detail:any;
    if(type == 1){
      detail = getLocalJSON('grw_excahngevalue');
    } else if(type == 2) { 
      detail = getLocalJSON('grw_new_excahngevalue');
    } else {
      detail = getLocalJSON('grw_gift_excahngevalue'); 
    }           
    var mm :any = amount / detail[cc]; 
    return parseFloat(mm).toFixed(2); 
  }
  
}

revertCurrency(type:any,cc:any,amount:any){ 
  if(parseInt(amount) == 0 ) { 
  return parseFloat(amount).toFixed(2); 
} else {
  var detail:any;
  if(type == 1){
    detail = getLocalJSON('grw_excahngevalue');
  } else { 
    detail = getLocalJSON('grw_new_excahngevalue');
  }            
  var mm :any = amount * detail[cc]; 
  return parseFloat(mm).toFixed(2); 
}

}

callBankLink(){
  this.GetApi('/link-account').subscribe(((response:any)=>{
    if(response.success ==1){
      window.open(response.data.data.url, '_blank');
    }
  }))
}

PostApiFormData(data: any, url: any) {
  return this.http
    .post<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
    .pipe(retry(0), catchError(this.handleError),
    map((data: []) => {
    const response: any = data;
    if (response.success == 0) {
      if (response.error_code == 461) {
        // this.dangerAlert(response.message);
        this.logOut();
        this.router.navigate(['/signin']);
      }
    }
    if(response.version.master_version > this.versions){
      this.getAllMasterData();
    }
    return data;
  }))
}


FLoatOnly(event:any): boolean { 
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 46 || charCode > 57) || charCode==47) {
    return false;
  }    
  var ss=event.target.value.split('.');
  if(ss.length >1){
    if(ss[1].length>1){
      return false;
    }      
  }
  return true;
}

}

